import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Sparkles, Check } from 'lucide-react';
export function LashesBrows() {
  const handleBooking = () => {
    window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer');
  };
  const highlights = ['Lifting y curvatura natural de pestañas', 'Extensiones pelo a pelo y volumen ruso', 'Diseño y laminado de cejas a medida', 'Tratamientos para todo tipo de mirada'];
  return <section className="py-24 bg-cream" data-id="element-145">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-147">
          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} data-id="element-148">
            <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-149">
              Pestañas & Cejas
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-charcoal mb-6 leading-tight" data-id="element-150">
              Una mirada que lo dice todo
            </h3>
            <p className="text-charcoal-light mb-8 text-lg font-light leading-relaxed" data-id="element-151">
              Realzamos tu mirada con técnicas precisas y resultados naturales.
              Desde el lifting que abre y curva tus pestañas, hasta el diseño y
              laminado que enmarca tu rostro a la perfección.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-152">
              {highlights.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-153">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-rosegold/15 flex items-center justify-center mt-0.5" data-id="element-154">
                    <Check size={14} className="text-rosegold" data-id="element-155" />
                  </span>
                  <span className="text-charcoal font-light" data-id="element-156">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-wrap gap-6 mb-10" data-id="element-157">
              <div className="flex items-center gap-3" data-id="element-158">
                <div className="w-11 h-11 rounded-full bg-white shadow-sm flex items-center justify-center border border-cream-dark text-rosegold" data-id="element-159">
                  <Eye size={20} data-id="element-160" />
                </div>
                <div data-id="element-161">
                  <p className="font-medium text-charcoal text-sm" data-id="element-162">Lashes</p>
                  <p className="text-charcoal-light text-sm font-light" data-id="element-163">
                    Lifting & extensiones
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-164">
                <div className="w-11 h-11 rounded-full bg-white shadow-sm flex items-center justify-center border border-cream-dark text-rosegold" data-id="element-165">
                  <Sparkles size={20} data-id="element-166" />
                </div>
                <div data-id="element-167">
                  <p className="font-medium text-charcoal text-sm" data-id="element-168">Brows</p>
                  <p className="text-charcoal-light text-sm font-light" data-id="element-169">
                    Diseño & laminado
                  </p>
                </div>
              </div>
            </div>

            <button onClick={handleBooking} className="bg-rosegold text-white px-8 py-3.5 rounded-full font-medium hover:bg-rosegold-dark transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-170">
              Reservá tu turno
            </button>
          </motion.div>

          {/* Image Gallery Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="grid grid-cols-2 gap-4" data-id="element-171">
            <div className="rounded-2xl overflow-hidden shadow-md col-span-2 aspect-[16/9] sm:aspect-[2/1]" data-id="element-172">
              <img src="https://cdn.magicpatterns.com/uploads/qY73KJ1CyWvFc97BviPovA/SaveClip.App_502309096_17931588249062830_2107869449766701969_n.jpg" alt="Diseño de cejas y lifting de pestañas" className="w-full h-full object-cover object-center" data-id="element-173" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-md aspect-square" data-id="element-174">
              <img src="https://cdn.magicpatterns.com/uploads/76h9LF8CRLHgup3gPeGCF9/SaveClip.App_532623418_17937343644062830_3950506819105330123_n.jpg" alt="Lifting de pestañas detalle" className="w-full h-full object-cover object-center" data-id="element-175" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-md aspect-square" data-id="element-176">
              <img src="https://cdn.magicpatterns.com/uploads/dsd6Zk1sbo9QiKZhwhSUCC/SaveClip.App_653940704_18094721558088954_3956665775261366443_n.jpg" alt="Diseño de cejas masculino" className="w-full h-full object-cover object-center" data-id="element-177" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}